import { aboutContent } from '../data/portfolio'
import { usePageTitle } from '../lib/hooks/usePageTitle'
import { PROJECT_TOPIC_LABEL_CLASS } from '../lib/projectTopicLabel'

const About = () => {
  usePageTitle('About')

  return (
    <section className="content-page relative px-5 py-4 md:px-8 md:py-5">
      <h1 className={`${PROJECT_TOPIC_LABEL_CLASS} mb-8`}>about</h1>

      <div className="mb-10 grid gap-8 md:grid-cols-[280px_1fr] md:items-start">
        <img
          src={`${process.env.PUBLIC_URL}/images/darren-about-icon.png`}
          alt="Darren Flowers-Finley portrait at night in the city"
          className="site-frame w-full max-w-[280px] object-cover"
        />

        <div className="min-w-0">
          <h2 className={`${PROJECT_TOPIC_LABEL_CLASS} mb-6`}>
            {aboutContent.headline}
          </h2>

          <div className="space-y-5">
            {aboutContent.body.map((paragraph) => (
              <p key={paragraph.slice(0, 24)} className="site-muted normal-case leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </div>

      <section className="mt-12 w-full border-t border-border pt-10">
        <h2 className={`${PROJECT_TOPIC_LABEL_CLASS} mb-6`}>Bio</h2>
        <div className="w-full space-y-5">
          {aboutContent.bio.map((paragraph) => (
            <p key={paragraph.slice(0, 24)} className="site-muted w-full normal-case leading-relaxed">
              {paragraph}
            </p>
          ))}
        </div>
      </section>

      <section className="mt-12 w-full border-t border-border pt-10">
        <h2 className={`${PROJECT_TOPIC_LABEL_CLASS} mb-6`}>Key Stats</h2>
        <div className="grid w-full auto-rows-fr gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {aboutContent.stats.map((stat) => (
            <div
              key={stat.label}
              className="site-frame flex h-full min-h-14 flex-col justify-center p-3"
            >
              <p className="site-label">{stat.value}</p>
              <p className="site-muted mt-1 normal-case leading-snug">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-12 w-full border-t border-border pt-10">
        <h2 className={`${PROJECT_TOPIC_LABEL_CLASS} mb-6`}>Primary Skills</h2>
        <ul className="grid w-full auto-rows-fr gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {aboutContent.primarySkills.map((skill) => (
            <li
              key={skill}
              className="site-frame flex h-full min-h-14 items-center p-3 site-muted normal-case leading-snug"
            >
              {skill}
            </li>
          ))}
        </ul>
      </section>
    </section>
  )
}

export default About
